import { type SlotDefinition, slots, SlotsDefinition, type SlotSizeMapping } from '@folklore/ads';
import isArray from 'lodash-es/isArray';
import isObject from 'lodash-es/isObject';

function addSizeToSlot(slot: SlotDefinition, newSize: SlotSizeMapping | string) {
    const { sizeMapping = null } = slot;
    const newSizesMapping = isObject(newSize) ? newSize : null;
    let newSizes;
    if (isObject(newSize)) {
        // newSizes = Object.keys(newSize).reduce((all, key) => [...all, ...newSize[key]], []);
        newSizes = [...(newSize.default || [])];
    } else if (isArray(newSize)) {
        newSizes = newSize;
    } else {
        newSizes = [newSize];
    }
    return {
        ...slot,
        ...(sizeMapping !== null
            ? {
                  sizeMapping: Object.keys(sizeMapping).reduce(
                      (acc2, key2) => ({
                          ...acc2,
                          [key2]: [
                              ...sizeMapping[key2],
                              ...(newSizesMapping !== null
                                  ? newSizesMapping[key2] || []
                                  : newSizes),
                          ],
                      }),
                      {},
                  ),
              }
            : null),
    };
}

const adsSlots: SlotsDefinition = {
    ...slots,
    fullwidth_native: addSizeToSlot(addSizeToSlot(slots.fullwidth, 'fluid'), {
        default: [
            [420, 640],
            [1080, 1920],
            [1920, 1080],
        ],
        tablet: [
            [420, 640],
            [740, 750],
            [1080, 1920],
            [1920, 1080],
        ],
        desktop: [
            [740, 750],
            [1024, 750],
            [1920, 1080],
        ],
        laptop: [
            [740, 750],
            [1024, 750],
            [1920, 1080],
        ],
    }),
    article_native: addSizeToSlot(addSizeToSlot(slots.content, 'fluid'), {
        default: [
            [420, 640],
            [1080, 1920],
            [1920, 1080],
        ],
        tablet: [
            [420, 640],
            [740, 750],
            [1080, 1920],
            [1920, 1080],
        ],
        desktop: [
            [740, 750],
            [1024, 750],
            [1920, 1080],
        ],
        laptop: [
            [740, 750],
            [1024, 750],
            [1920, 1080],
        ],
    }),
    fullwidth: addSizeToSlot(slots.fullwidth, {
        desktop: [[300, 250]],
        laptop: [[300, 250]],
    }),
    content: addSizeToSlot(slots.content, {
        desktop: [[300, 250]],
        laptop: [[300, 250]],
    }),
    article: addSizeToSlot(slots.content, {
        desktop: [[300, 250]],
        laptop: [[300, 250]],
    }),
    // Top of every page: formats of at most 100px high
    header: {
        sizeMapping: {
            default: [
                [320, 50],
                [320, 100],
                [300, 50],
                [300, 100],
            ],
            tablet: [
                [728, 90],
                [320, 50],
                [320, 100],
                [300, 50],
                [300, 100],
            ],
            desktop: [
                [728, 90],
                [970, 90],
            ],
            laptop: [
                [728, 90],
                [970, 90],
            ],
        },
    },
    bumper: {
        size: [
            [1080, 1920],
            [1920, 1080],
        ],
        sizeMapping: {
            default: [[1080, 1920]],
            tablet: [
                [1080, 1920],
                [1920, 1080],
            ],
            desktop: [
                [1080, 1920],
                [1920, 1080],
            ],
            laptop: [
                [1080, 1920],
                [1920, 1080],
            ],
        },
    },
    list_native: {
        size: ['fluid'],
        sizeMapping: {
            default: ['fluid'],
            tablet: ['fluid'],
            desktop: ['fluid'],
            laptop: ['fluid'],
        },
    },
};

export default adsSlots;
